// extracted by mini-css-extract-plugin
export default {"select":"SelectCellColored_select__0x9Q8"};